

import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Observable, takeUntil, withLatestFrom } from 'rxjs';
import { NgxsFormPluginModule } from '@ngxs/form-plugin';
import { Select, ofActionSuccessful } from '@ngxs/store';
import { TranslateModule } from '@ngx-translate/core';

import { WebApiResponseBase } from '@app/shared/classes/general';
import { NgxsActionName, NgxsFormPath } from '@app/shared/constants';
import { AngularMaterialModule } from '@app/shared/modules/angular-material.module';
import { AppDataState } from '@app/shared/stores/app-data.state';
import { EditModalDialogBasedComponent } from '@shared/components/edit-modal-dialog/edit-modal-dialog.based.component';
import { SpinnerButtonComponent } from '@shared/components/spinner-button/spinner-button.component';
import * as AppDataAction from '@app/shared/actions/app-data.action';
import { InjectDialogData } from '@shared/components/edit-modal-dialog/edit-modal-dialog.constant';
import { UserProfileSearchGridComponent } from '@shared/components/user-profile-search-grid/user-profile-search-grid.component';
import { ReportLink } from '@app/shared/classes/report-link';
import { SiteConfigHelper } from '@app/shared/utils/site-config.helper';

@Component({
  selector: 'app-report-link-edit-modal-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, SpinnerButtonComponent, TranslateModule, NgxsFormPluginModule, ReactiveFormsModule, MatDialogModule, AngularMaterialModule, UserProfileSearchGridComponent],
  templateUrl: './report-link-edit-modal-dialog.component.html',
  styleUrl: './report-link-edit-modal-dialog.component.css'
})
export class ReportLinkEditModalDialogComponent extends EditModalDialogBasedComponent<ReportLinkEditModalDialogComponent, ReportLink> {
  formPath = NgxsFormPath.REPORT_LINK_EDIT_FORM;
  countrySelectItems = SiteConfigHelper.GetCountryCodeDropDownList();
  title = "";

  @Select(AppDataState.taskExecuting(NgxsActionName.UPDATE_REPORT_LINK)) processing$: Observable<boolean>;
  @Select(AppDataState.taskError(NgxsActionName.UPDATE_REPORT_LINK)) errorResponse$: Observable<WebApiResponseBase>;
  @Select(AppDataState.taskResponse(NgxsActionName.UPDATE_REPORT_LINK)) successResponse$: Observable<WebApiResponseBase>;

  constructor(public dialogRef: MatDialogRef<ReportLinkEditModalDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: InjectDialogData<ReportLink>) {
    super();
    this.dataInit(dialogRef, data);
    this.isCreate = data.isCreate;
    this.initForm(data);
    this.title = data.isCreate ? "ml_144036" : "ml_143925";
  }

  initForm = (data: InjectDialogData<ReportLink>) => {
    if (data.isCreate) {
      this.editForm = this.formBuilder.group({
        reportLink_Id: -1,
        reportName: ["", Validators.required],
        reportUrl: ["", Validators.required],
        description: [""],
        country: ["", Validators.required],
      });
    }
    else {
      this.editForm = this.formBuilder.group({
        reportLink_Id: data.data.reportLink_Id,
        reportName: [data.data.reportName, Validators.required],
        reportUrl: [data.data.reportUrl, Validators.required],
        description: [data.data.description],
        country: [data.data.country, Validators.required],
      });
    }
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.actions$.pipe(ofActionSuccessful(AppDataAction.UpdateReportLink), withLatestFrom(this.errorResponse$), takeUntil(this.destroy$)).subscribe(
      ([_, errorResponse]) => this.processAfterUpdateObject(errorResponse));
  }

  onOkClick = () => {
    this.store.dispatch(new AppDataAction.UpdateReportLink());
  }

  override ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}
